import { Validator, VARIABLE_VALIDATION_REGEX } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/Validator';
import { ValidationError } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/ValidatorError';
import { CommandMethods } from 'types/CommandMethods';
export class ProcessCommandActionSettingsValidator extends Validator {
    validate(model) {
        if (!model.to) {
            throw new ValidationError('The command to is required');
        }
        if (!model.uri) {
            throw new ValidationError('The command uri is required');
        }
        if (model.uri && !(model.uri.startsWith('lime://') || model.uri.startsWith('/'))) {
            throw new ValidationError('The URI has to start with lime:// or /');
        }
        if ((model.method === CommandMethods.set || model.method === CommandMethods.merge) && !model.type) {
            throw new ValidationError('The type is required');
        }
        if ((model.method === CommandMethods.set || model.method === CommandMethods.merge) && !model.resource) {
            throw new ValidationError('The resource is required');
        }
        if (!model.variable.match(VARIABLE_VALIDATION_REGEX)) {
            throw new ValidationError('The script output variable name should be composed only by letters, numbers and dots');
        }
    }
}
